module.exports = __webpack_public_path__ + "static/media/Tick.748c714d.svg";